import React from "react";
import Hero from "../../components/sections/Home/Hero";
//import ComingSoon from "../../components/shared/ComingSoon";
// import About from "../../components/sections/Home/About";
// import TotalPrize from "../../components/sections/Home/TotalPrize";
// import Podium from "../../components/sections/Home/Podium";
// import Sponsor from "../../components/sections/Home/Sponsor";
// import Register from "../../components/sections/Home/Register";
// import PopupImage from "../../assets/images/pop-up.png"

export default function AlternateHome() {
    // const [showPopup, setShowPopup] = useState(false);

    // useEffect(() => {
    //     setShowPopup(true);
    // }, []);

    // useEffect(() => {
    //     if (showPopup) {
    //       document.body.style.overflow = "hidden";
    //     } else {
    //       document.body.style.overflow = "";
    //     }
    //   }, [showPopup]);

    // const closePopup = () => setShowPopup(false);

    return (
        <>
            {/* <ComingSoon /> */}
            <Hero />
            {/* <Register />
            <About />
            <Podium />
            <TotalPrize />
            <Sponsor /> */}

            {/* {showPopup && (
              <div
                className="fixed inset-0 bg-black/60 flex items-center justify-center z-[999] backdrop-blur-sm"
                onClick={closePopup}
              >
                <div
                  className="relative w-[90%] max-w-md max-h-[90vh] overflow-hidden bg-transparent"
                  onClick={(e) => e.stopPropagation()}
                >
                  <button
                    className="absolute top-3 right-3 z-10 text-white bg-black/60 hover:bg-black/80 rounded-full p-2 leading-none"
                    onClick={closePopup}
                  >
                    ✕
                  </button>
                  <img
                    src={PopupImage}
                    alt="Promo"
                    className="w-full h-auto max-h-[90vh] object-contain block"
                    draggable={false}
                  />
                </div>
              </div>
            )} */}
        </>
    );
}
